module.exports = __webpack_public_path__ + "site/img/p3.d81d3ffd.png";